var _rect, _line, _g, _circle, _line2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 48,
    height: 44,
    rx: 6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 22,
    x2: 56,
    y2: 22
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 16,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 16,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 16,
    r: 1.6
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 38,
    r: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 38,
    x2: 42,
    y2: 38
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 28 c5 5 5 15 0 20 c-5 -5 -5 -15 0 -20 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/browser.9ec5a922d151f5e68d4074a8b839305f.svg";
export { ForwardRef as ReactComponent };